<template>
  <div class="body-mobile">
    <div class="container-vertical-middle container-full-width">
      <h2 class="text-h3" style="font-size: 28px; padding-bottom: 25px; font-weight: 100;">{{sysName}}查询</h2>
      <div class="box-shadow">
        <md-field>
          <md-input-item
            v-model="studentSignupId"
            title="预报名号"
            placeholder="请输入预报名号"
            is-amount
          ></md-input-item>
          <md-input-item
            v-model="idCard"
            title="身份证号"
            placeholder="请输入身份证号"
            is-amount
            :maxlength="18"
          ></md-input-item>
        </md-field>
      </div>
      <div class="box-btns">
        <span class="button-primary-inset" @touchstart="handleSubmit">查 询</span>
      </div>
    </div>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
  import PageLogin from '../index/mixins/page_login';

  export default {
    mixins: [IndexCommon, MobileCommon, PageLogin],
    components: {},
    data() {
      return {
        studentSignupId: '',
        idCard: ''
      }
    },
    created() {
    },
    methods: {
      handleSubmit() {
        if (!this.studentSignupId) {
          this.$message.error('预报名号不能为空！');
        } else if (!this.idCard) {
          this.$message.error('身份证号不能为空！');
        } else if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.idCard)) {
          this.$message.error('身份证号格式错误！');
        } else {
          console.log('-> handleNextStep success', this.studentApplyType);
          let formVal = {
            studentSignupId: this.studentSignupId,
            idCard: this.idCard
          };
          this.ajaxSearchSignupApply(formVal);
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>

  .body-mobile
    background-image url('./images/bg1.png')

  .container-vertical-middle
    top 40%

  .text-h3
    text-align center
    margin 60px 0

  .button-primary-inset
    width 70%
</style>
